export interface NotificationPrefs {
  user_id: string;
  interview_reminders: boolean;
  daily_practice: boolean;
  daily_practice_hour: number;
  weekly_progress: boolean;
  timezone: string;
  created_at?: string;
  updated_at?: string;
}

export type NotificationPrefsUpdate = Pick<
  NotificationPrefs,
  | 'interview_reminders'
  | 'daily_practice'
  | 'daily_practice_hour'
  | 'weekly_progress'
  | 'timezone'
>;

export const DEFAULT_NOTIFICATION_PREFS: NotificationPrefsUpdate = {
  interview_reminders: true,
  daily_practice: true,
  daily_practice_hour: 9,
  weekly_progress: false,
  timezone: 'UTC',
};
